module.exports = __webpack_public_path__ + "static/media/26_tn.e97a8980.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/26_tn.jpg
// module id = 164
// module chunks = 0